import { cartoThemeOptions } from '@carto/react-ui';
import { createTheme, darken, lighten } from '@material-ui/core';
import deepmerge from 'deepmerge';

const primary = '#30704c';
const orange = '#ef4631';

const customTheme = {
  palette: {
    primary: {
      light: lighten(primary, 0.25),
      main: primary,
      dark: darken(primary, 0.25),
    },
    secondary: {
      light: lighten('#5268B4', 0.25),
      main: '#5268B4',
      dark: darken('#5268B4', 0.25),
      contrastText: '#fff',
    },
  },
  overrides: {
    MuiButton: {
      containedPrimary: {
        light: lighten(orange, 0.25),
        main: orange,
        dark: darken(orange, 0.25),
      },
      containedSecondary: {
        '&:hover': {
          backgroundColor: darken('#5268B4', 0.25),
        },
      },
    },
  },
};
const theme = createTheme(deepmerge(cartoThemeOptions, customTheme));

export default theme;
